import { Trans } from '@lingui/react/macro';

import ChevronDown from '@/assets/svg/chevron-down.svg?react';
import { Button } from '@/components/buttons';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/DropdownMenu';
import InstantSearchInput from '@/components/InstantSearchInput';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import useInstanceNavigate from '@/hooks/useInstanceNavigate';
import { useMe } from '@/providers/User';
import { ROUTES } from '@/router';

const AUDIENCE_TYPE = {
  AI_BASED: 'AI_BASED',
  CUSTOM: 'CUSTOM',
  CRM: 'CRM',
  RULE_BASED: 'RULE_BASED',
} as const;

const AudiencesListHeader = () => {
  const navigate = useInstanceNavigate();
  const user = useMe();

  const handleCreateAudience = (key: string) => {
    switch (key) {
      case AUDIENCE_TYPE.AI_BASED:
        navigate(ROUTES.audienceAIBasedCreate.path);
        return;
      case AUDIENCE_TYPE.CRM:
        navigate(ROUTES.audienceImport.path);
        return;
      case AUDIENCE_TYPE.RULE_BASED:
        navigate(ROUTES.audienceRuleBuilderCreate.path);
        return;
      default:
        navigate(ROUTES.audienceCSVCreate.path);
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div>
        {user?.isAdmin && (
          <DropdownMenu>
            <DropdownMenuTrigger
              render={
                <Button variant="primary">
                  <span className="flex items-center gap-2">
                    <Trans>Create Audience</Trans>
                    <ChevronDown className="relative -right-1 scale-125" />
                  </span>
                </Button>
              }
              openOnHover
            />
            <DropdownMenuContent>
              <DropdownMenuItem onClick={() => handleCreateAudience(AUDIENCE_TYPE.CUSTOM)}>
                <Trans>CSV/File</Trans>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleCreateAudience(AUDIENCE_TYPE.CRM)}>
                <Trans>CRM</Trans>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleCreateAudience(AUDIENCE_TYPE.RULE_BASED)}>
                <Trans>Rule-Based</Trans>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleCreateAudience(AUDIENCE_TYPE.AI_BASED)}>
                <Trans>AI-Based</Trans>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
      <div className="flex items-center gap-2">
        <PendoPlaceholder />
        <InstantSearchInput />
      </div>
    </div>
  );
};

export default AudiencesListHeader;
